import { useSEO } from "@/contexts/SeoContext.tsx";
import { useEffect } from "react";
import LoginUserForm from "@/components/auth/LoginForm.tsx";

export default function Login() {
  const { setTitle, setDescription } = useSEO();

  useEffect(() => {
    setTitle("Login");
    setDescription("Login to your account");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <LoginUserForm />
    </>
  );
}
